import { useState } from "react";
import { Box, Collapse, Typography } from "@mui/material";
import {
  ExpandMore as ExpandMoreIcon,
  ExpandLess as ExpandLessIcon,
} from "@mui/icons-material";

// Minimal reusable disclosure card: an indigo-tinted header row (title +
// optional status indicator + collapsed summary + optional header actions +
// chevron) over a Collapse body.
// Each instance manages its own open state so several can be open at once.
const CollapsibleCard = ({
  title,
  statusIndicator,
  summary,
  headerActions,
  defaultExpanded = true,
  children,
}) => {
  const [open, setOpen] = useState(Boolean(defaultExpanded));

  return (
    <Box
      sx={{
        border: "1px solid #E8EAF6",
        borderRadius: 2,
        backgroundColor: "#FFFFFF",
        boxShadow: "0 1px 3px rgba(63,81,181,0.10)",
        overflow: "hidden",
      }}
    >
      <Box
        onClick={() => setOpen((v) => !v)}
        sx={{
          display: "flex",
          alignItems: "center",
          gap: 1,
          px: 1.25,
          py: 1,
          cursor: "pointer",
          userSelect: "none",
          backgroundColor: "#F4F5FB",
          borderBottom: open ? "1px solid #E8EAF6" : "1px solid transparent",
          "&:hover": { backgroundColor: "#F4F5FB" },
        }}
      >
        <Typography sx={{ fontSize: 12.5, fontWeight: 700, color: "#1A1F36", flexShrink: 0 }}>
          {title}
        </Typography>
        {statusIndicator}
        {!open && summary ? (
          <Typography
            sx={{
              flex: 1,
              minWidth: 0,
              fontSize: 11.5,
              color: "#3949AB",
              whiteSpace: "nowrap",
              overflow: "hidden",
              textOverflow: "ellipsis",
            }}
          >
            {summary}
          </Typography>
        ) : (
          <Box sx={{ flex: 1 }} />
        )}
        {headerActions ? (
          // Actions live inside the clickable header row; keep clicks on them
          // from toggling the card.
          <Box onClick={(e) => e.stopPropagation()} sx={{ display: "flex", alignItems: "center", flexShrink: 0 }}>
            {headerActions}
          </Box>
        ) : null}
        {open ? (
          <ExpandLessIcon sx={{ fontSize: 18, color: "#3949AB", flexShrink: 0 }} />
        ) : (
          <ExpandMoreIcon sx={{ fontSize: 18, color: "#3949AB", flexShrink: 0 }} />
        )}
      </Box>
      <Collapse in={open} unmountOnExit={false}>
        <Box sx={{ px: 1.25, py: 1.25, display: "flex", flexDirection: "column", gap: 1 }}>
          {children}
        </Box>
      </Collapse>
    </Box>
  );
};

export default CollapsibleCard;
